var Size;
(function (Size) {
    Size["LARGE"] = "lg";
    Size["MEDIUM"] = "md";
    Size["NONE"] = "";
    Size["SMALL"] = "sm";
    Size["XSMALL"] = "xsm";
})(Size || (Size = {}));
export default Size;
//# sourceMappingURL=size.js.map